<template>
  <el-menu mode="horizontal" @select="selectMenuItem">
    <el-menu-item index="listItem" id="nav-menu-list-item">商品一覧</el-menu-item>
    <el-menu-item index="newItem" id="nav-menu-new-item">データ作成</el-menu-item>
    <el-menu-item index="userConf" id="nav-menu-user-conf">ユーザ設定</el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: 'NavMenu',
  data: function () {
    return {
      mapRoutes: {
        listItem: () => this.$router.push({ name: 'ItemList' }),
        newItem: () => this.$router.push({ name: 'NewItem', param: {} }),
        userConf: () => this.$router.push({ name: 'UserConf' })
      }
    }
  },
  methods: {
    selectMenuItem: function (index) {
      this.mapRoutes[index]()
    }
  }
}
</script>
